<template>
  <div>
    <div v-if="!isHidden" :class="['modal-backdrop', 'fade', {'in': isOpen}]"></div>
    <div :class="['modal', 'fade', {'modal-fixed': fixed !== false, 'in': isOpen}]" tabindex="-1" role="dialog" :aria-labelledby="arialLabel" :style="modalStyles">
      <div :class="['modal-dialog', ('modal-' + size)]">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="clickClose"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title">{{ title }}</h4>
          </div>
          <div :class="['modal-body', {'no-padding': noPadding}]">
            <alert
              :title="alert"
              :text="alertText"
              :color="alertStyle"
              :icon="alertIcon"
              :dismissable="alertDismissable"
              v-on:dismiss="dismissAlert"
            ></alert>
            <slot></slot>
          </div>
          <div v-if="!noFooter" class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    alert: {
      type: String
    },
    alertText: {
      type: String
    },
    alertStyle:  {
      type: String
    },
    alertIcon:  {
      type: String
    },
    alertDismissable: {
      type: Boolean,
      default: false
    },
    isHidden: {
      type: Boolean,
      default: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    arialLabel: {
      type: String
    },
    title: {
      type: String
    },
    size: {
      type: String,
      default: 'md' // Other: lg, sm
    },
    loader: {
      type: String,
      default: 'Loading'
    },
    noFooter: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    modalStyles() {
      if (!this.isHidden) {
        return {
          display: 'block',
          'padding-right': '15px'
        };
      }

      return {
        display: 'none'
      };
    }
  },
  methods: {
    dismissAlert() {
      this.$emit('dismissalert');
    },
    toggle(ref) {
      if (ref.isOpen) {
        this.close(ref);
      } else {
        this.open(ref);
      }
    },
    clickClose() {
      this.$emit('clickclose');
    },
    open(ref) {
      this.$emit('open');

      ref.isHidden = false;
      setTimeout(function(){
        ref.isOpen = true;
      }, 200);
    },
    close(ref) {
      this.$emit('close');

      ref.isOpen = false;
      setTimeout(function(){
        ref.isHidden = true;
      }, 200);
    }
  }
}
</script>
